import styled from 'styled-components';

export const BeforeAfterSliderWrapper = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
  z-index: 1;

  .--pane {
    top: 0;
    position: absolute;
    height: 100%;
    width: 100%;
  }
  img {
    user-select: none;
  }
  .--first-photo-container,
  .--second-photo-container {
    background: transparent;
    > img {
      width: 100%;
      -moz-user-select: none;
      -webkit-user-select: none;
      user-select: none;
    }
  }
  .--delimiter {
    position: absolute;
    height: 100%;
    background: #fff;
    width: 5px;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .--delimiter-icon {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #fff;
    cursor: col-resize;
  }

  .--size-fix-img {
    width: 100%;
    opacity: 0;
  }
`;
